import { ImportableBattery, Battery, BatteryImportDTO, BatteryUploadDTO } from "../models/Battery";
import client from "./axios";

const batteriesUrl = `${window.__env.CORE_URL}/batteries`;
const tenantBatteryUrl = `${window.__env.BASE_URL}/batteries`;

export const Batteries = {
  getBatteries: () => client.get<Battery[]>(batteriesUrl),
  getTenantBatteries: () => client.get<Battery[]>(tenantBatteryUrl),
  getBattery: (id: string) => client.get<Battery>(`${tenantBatteryUrl}/${id}`),
  getImportableBatteries: () => client.get<ImportableBattery[]>(`${window.__env.BASE_URL}/upload?uploaded=false&type=batteries`),
  createBattery: (battery: Battery) => client.post<Battery>(batteriesUrl, battery),
  updateBattery: (battery: Battery) => client.put<Battery>(`${batteriesUrl}/${battery.id}`, battery),
  deleteBattery: (id: string) => client.delete<Battery>(`${batteriesUrl}/${id}`),
  deleteTenantBattery: (id: string) => client.delete<Battery>(`${tenantBatteryUrl}/${id}`),
  uploadBatteries: (uploadDto: BatteryUploadDTO) => client.put<BatteryUploadDTO>(`${window.__env.CORE_URL}/upload`, uploadDto),
  importBatteries: (importBatteries: BatteryImportDTO[]) => client.put<BatteryImportDTO[]>(`${window.__env.BASE_URL}/import`, importBatteries)
}